module.exports = __webpack_public_path__ + "img/airway_icon.46373f21.png";